import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import AnalyticsTracker from './components/AnalyticsTracker';
import Home from './pages/Home';
import Works from './pages/Works';
import ProductsOverview from './pages/ProductsOverview';
import LedVision from './pages/LedVision';
import IndoorLedVision from './pages/IndoorLedVision';
import OutdoorLedVision from './pages/OutdoorLedVision';
import SpecialLedVision from './pages/SpecialLedVision';
import ElectricBoard from './pages/ElectricBoard';
import SecurityCamera from './pages/SecurityCamera';
import SecurityCameraLineup from './pages/SecurityCameraLineup';
import SecurityCameraServices from './pages/SecurityCameraServices';
import ActiveDeterrenceCamera from './pages/ActiveDeterrenceCamera';
import IpCamera from './pages/IpCamera';
import SuperColorVu from './pages/SuperColorVu';
import PtzCamera from './pages/PtzCamera';
import IrNightVision from './pages/IrNightVision';
import LprCamera from './pages/LprCamera';
import MiniHiddenFisheye from './pages/MiniHiddenFisheye';
import WifiCamera from './pages/WifiCamera';
import AnalogCamera from './pages/AnalogCamera';
import NvrRecorder from './pages/NvrRecorder';
import Signage from './pages/Signage';
import ChannelLetters from './pages/ChannelLetters';
import LedLighting from './pages/LedLighting';
import ParkingSystem from './pages/ParkingSystem';
import EmergencyBoard from './pages/EmergencyBoard';
import EmergencyBoardStandalone from './pages/EmergencyBoardStandalone';
import CustomMetal from './pages/CustomMetal';
import ConstructionSupport from './pages/ConstructionSupport';
import CompanyInfo from './pages/CompanyInfo';
import Contact from './pages/Contact';
import AdminInquiries from './pages/AdminInquiries';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AnalyticsTracker />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="works" element={<Works />} />
            <Route path="products" element={<ProductsOverview />} />
            <Route path="products/led-vision" element={<LedVision />} />
            <Route path="products/led-vision/indoor" element={<IndoorLedVision />} />
            <Route path="products/led-vision/outdoor" element={<OutdoorLedVision />} />
            <Route path="products/led-vision/special" element={<SpecialLedVision />} />
            <Route path="products/electric-board" element={<ElectricBoard />} />
            <Route path="products/security-camera" element={<SecurityCamera />} />
            <Route path="services/security-camera" element={<SecurityCameraServices />} />
            <Route path="services/security-camera/lineup" element={<SecurityCameraLineup />} />
            <Route
              path="services/security-camera/active-deterrence-camera"
              element={<ActiveDeterrenceCamera />}
            />
            <Route path="services/security-camera/ip-camera" element={<IpCamera />} />
            <Route path="services/security-camera/super-colorvu" element={<SuperColorVu />} />
            <Route path="services/security-camera/ptz-camera" element={<PtzCamera />} />
            <Route path="services/security-camera/ir-night-vision" element={<IrNightVision />} />
            <Route path="services/security-camera/lpr-ip-camera" element={<LprCamera />} />
            <Route path="services/security-camera/mini-hidden-fisheye" element={<MiniHiddenFisheye />} />
            <Route path="services/security-camera/wifi-camera" element={<WifiCamera />} />
            <Route path="services/security-camera/analog-camera" element={<AnalogCamera />} />
            <Route path="services/security-camera/nvr-recorder" element={<NvrRecorder />} />
            <Route path="products/signage" element={<Signage />} />
            <Route path="products/signage/channel-letters" element={<ChannelLetters />} />
            <Route path="products/led-lighting" element={<LedLighting />} />
            <Route path="products/parking-system" element={<ParkingSystem />} />
            <Route path="products/emergency-board" element={<EmergencyBoard />} />
            <Route path="products/emergency-board/standalone" element={<EmergencyBoardStandalone />} />
            <Route path="products/custom-metal" element={<CustomMetal />} />
            <Route path="construction-support" element={<ConstructionSupport />} />
            <Route path="company" element={<CompanyInfo />} />
            <Route path="contact" element={<Contact />} />
          </Route>
          {/* Admin routes — not linked in public navigation */}
          <Route path="/admin/inquiries" element={<AdminInquiries />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
